// Copyright © 2021 Move Closer
import { abstractModalProps, useModal } from '../../_abstract';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapModalProps = {
    ...abstractModalProps
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const useBootstrapModal = (props, ctx) => {
    const { close } = useModal(props, ctx);
    return { close };
};
